<template>
  <ZMainPage type="card" :loading="loading">
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text">基础信息</span>
      </div>
      <LineWrapper list column="3" label-width="160rem">
        <LineItem v-for="item in list1" :key="item.label" :label="item.label">
          <span class="mr-1" v-if="item.value">{{ item.value }}</span>
          <span class="text-primary c-p" v-if="item.button" @click="handlePreview(item.type)">{{ item.button }}</span>
        </LineItem>
      </LineWrapper>
    </div>
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text mr-2">缴费详情</span>
        <template v-if="diff_fee_tag.length">
          <ZuTips v-if="item.name" :value="item.name" :type="item.type === 1 ? 'red' : 'orange'" v-for="(item, idx) in diff_fee_tag" :key="idx" />
        </template>
      </div>
      <LineWrapper list column="3" labelWidth="160rem">
        <LineItem class="item" v-for="item in list2" :key="item.label" :label="item.label" :value="item.value" :cssStyle="item.cssStyle"></LineItem>
      </LineWrapper>
      <template v-if="is_pay">
        <LineWrapper list column="3" labelWidth="160rem">
          <LineItem label="实缴金额及方式">
            <div style="width: 700rem;">
              <CustomTable :data="data" :config="config" type="gray" />
              <ZuTips class="mt-2" :value="sumAmount" type="info" showIcon />
            </div>
          </LineItem>
        </LineWrapper>
        <LineWrapper labelWidth="160rem">
          <LineItem label="备注" v-for="item in list3" :key="item.label" :label="item.label" :value="item.value"></LineItem>
        </LineWrapper>
      </template>
    </div>
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text">操作记录</span>
      </div>
      <LineWrapper list column="3">
        <LineItem class="item" v-for="item in list4" :key="item.label" :label="item.label" :value="item.value" :cssStyle="item.cssStyle"></LineItem>
      </LineWrapper>
    </div>
    <template slot="footer">
      <el-button type="primary" @click="$router.back()">返回</el-button>
    </template>
  </ZMainPage>
</template>

<script>
import LineWrapper from '@/components/common/LineWrapper'
import LineItem from '@/components/common/LineItem'
import ZuTips from '@/components/common/ZuTips'
import CustomTable from '@/components/common/CustomTable'
import { preciseAdd } from '@/utils'
import http from '@/api'
export default {
	_config:{'route':{'path':'look-xf','meta':{'title':'审批'}}},
  components: { LineWrapper, LineItem, ZuTips, CustomTable },
  data() {
    return {
      loading: false,
      is_pay: 0,
      list1: [],
      list2: [],
      list3: [],
      list4: [],
      diff_fee_tag: [],
      data: [],
      config: [],
      sumAmount: 0
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      http({ url: '/recruit-v2/order-offline/show?id=' + this.$route.query.id, pre: 'zs'}).then((res) => {
        this.diff_fee_tag = res.tag || []
        const list1 = [
          { label: '订单编号', value: res.order_number },
          { label: '入账学校', value: res.school },
          { label: '订单类型', value: res.order_type_name },
          { label: '学生姓名', value: res.student_name },
          { label: '学生身份证号/护照号', value: res.student_idcard },
          { label: '缴费学年', value: res.school_year },
          { label: '就读年级', value: res.grade_name },
          { label: '行政班', value: res.class_name },
          { label: '就读校区', value: res.studying_school_name },
          // { label: '当前客户归属招生老师', value: res.belong_teacher }
        ]
        const arr = ['否', '是', '部分欠缴']
        const list2 = [
          { label: '应缴金额', value: res.money_answer },
          { label: '是否缴费', value: res.is_pay },
        ]
        if (res.is_pay === '是') {
          this.is_pay = 1
          list2.push({ label: '是否分期', value: arr[res.is_by_stages] })
          list2.push({ label: '实缴金额', value: res.stages_first_money_actual })
          if (res.is_by_stages) {
            list2.push({ label: '欠缴金额', value: res.stages_first_money_not_paid })
          }
          // list2.push({ label: '缴费时间', value: res.payment_at })
        } else {
          list2.push({ label: '驳回原因', value: res.reason, cssStyle: {'grid-column': '1 / 3' } })
        }
        this.list1 = list1
        this.list2 = list2
        const { payment_detail } = res
        // 实缴金额及方式 利息减免金额：{{ domain.interest_amount }}
        if (!(payment_detail.length === 1 && Number(payment_detail[0].paid_amount) === 0)) {
          this.data = payment_detail.map(i => {
            return {
              paid_amount: i.paid_amount,
              payment_method: i.payment_method,
              payer: i.payer,
              payment_at: i.payment_at
            }
          })
          this.config = [
            { prop: 'paid_amount', label: '学生缴费金额', type: 'other' },
            { prop: 'payment_method', label: '学生缴费方式', type: 'other' },
            { prop: 'payer', label: '付款人姓名', type: 'other' },
            { prop: 'payment_at', label: '缴费时间', type: 'other' }
          ]
          const sum = payment_detail.reduce((pre, cur) => preciseAdd(pre, Number(cur.paid_amount) || 0), 0)
          this.sumAmount = `累计实缴金额：${sum}`
        }
        
        const list3 = []
        if (res.reason) {
          list3.push({ label: '备注', value: res.reason })
        }
        this.list3 = list3
        // 操作记录
        this.list4 = [
          { label: '操作人', value: res.approval_creator },
          { label: '操作时间', value: res.approval_at, cssStyle: {'grid-column': '2 / -1' }},
        ]
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>


<style lang="scss" scoped></style>
